import React, { useContext } from 'react'
import { NecttosContext } from '../../context/NecttosContext'
import PrimaryDashboard from '../Dashboard/PrimaryDashboard'
import SecondaryDashboard from '../Dashboard/SecondaryDashboard'

function App() {
    const { dashboard } = useContext(NecttosContext);

    switch(dashboard) {
        case 'primary': 
            return <PrimaryDashboard />;
        case 'secondary': 
            return <SecondaryDashboard />;
        default: 
            return <PrimaryDashboard />;
    }
}

export default App;
